import {
  IntIteratordtlvcwxsuu5a as IntIterator,
  CharIterator2h6gbyxoj1es2 as CharIterator,
} from '../collections/PrimitiveIterators.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  Char__toInt_impl_vasixd3jl92hthlhyn7 as Char__toInt_impl_vasixd,
  Char__compareTo_impl_ypi4mb3frsmupst9pih as Char__compareTo_impl_ypi4mb,
} from '../Char.mjs';
import { numberToChar93r9buh19yek as numberToChar } from '../js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IntProgressionIteratorClass;
function IntProgressionIterator() {
  if (IntProgressionIteratorClass === VOID) {
    class $ extends IntIterator() {
      constructor(first, last, step) {
        super();
        this.fp_1 = step;
        this.gp_1 = last;
        this.hp_1 = this.fp_1 > 0 ? first <= last : first >= last;
        this.ip_1 = this.hp_1 ? first : this.gp_1;
      }
      v1() {
        return this.hp_1;
      }
      sk() {
        var value = this.ip_1;
        if (value === this.gp_1) {
          if (!this.hp_1)
            throw NoSuchElementException().y6();
          this.hp_1 = false;
        } else {
          this.ip_1 = this.ip_1 + this.fp_1 | 0;
        }
        return value;
      }
    }
    initMetadataForClass($, 'IntProgressionIterator');
    IntProgressionIteratorClass = $;
  }
  return IntProgressionIteratorClass;
}
var CharProgressionIteratorClass;
function CharProgressionIterator() {
  if (CharProgressionIteratorClass === VOID) {
    class $ extends CharIterator() {
      constructor(first, last, step) {
        super();
        this.jp_1 = step;
        var tmp = this;
        // Inline function 'kotlin.code' call
        tmp.kp_1 = Char__toInt_impl_vasixd(last);
        this.lp_1 = this.jp_1 > 0 ? Char__compareTo_impl_ypi4mb(first, last) <= 0 : Char__compareTo_impl_ypi4mb(first, last) >= 0;
        var tmp_0 = this;
        var tmp_1;
        if (this.lp_1) {
          // Inline function 'kotlin.code' call
          tmp_1 = Char__toInt_impl_vasixd(first);
        } else {
          tmp_1 = this.kp_1;
        }
        tmp_0.mp_1 = tmp_1;
      }
      v1() {
        return this.lp_1;
      }
      uk() {
        var value = this.mp_1;
        if (value === this.kp_1) {
          if (!this.lp_1)
            throw NoSuchElementException().y6();
          this.lp_1 = false;
        } else {
          this.mp_1 = this.mp_1 + this.jp_1 | 0;
        }
        return numberToChar(value);
      }
    }
    initMetadataForClass($, 'CharProgressionIterator');
    CharProgressionIteratorClass = $;
  }
  return CharProgressionIteratorClass;
}
//region block: exports
export {
  CharProgressionIterator as CharProgressionIterator34nq4ujuknl08,
  IntProgressionIterator as IntProgressionIterator2ovd1ctrmu51n,
};
//endregion

//# sourceMappingURL=ProgressionIterators.mjs.map
